import { C } from "@/brand/tokens";
import { usePageMeta } from "@/lib/usePageMeta";
import { SiteHeader6 } from "@/components/layout/SiteHeader6";
import { SiteFooter6 } from "@/components/layout/SiteFooter6";
import {
  HeroSection6,
  SituationsSection6,
  ServicesSection6,
  WhyFirmSection6,
  ResourcesPreviewSection6,
  ProcessSection6,
  FinalCtaSection6,
} from "@/components/sections6";

/**
 * Faith 1st Consulting — firm-first B2B sales lobby homepage.
 * Sequence: Hero → Recognition → Services (2×2) → Why the firm →
 * Resources preview → Compact process → Final CTA.
 */
export default function Home() {
  usePageMeta({});
  return (
    <main
      data-testid="home-page"
      className="min-h-screen"
      style={{
        background: C.surfaceLight,
        color: C.textOnLight,
        fontFamily: "Inter, sans-serif",
      }}
    >
      <SiteHeader6 />
      <HeroSection6 />
      <SituationsSection6 />
      <ServicesSection6 />
      <WhyFirmSection6 />
      <ResourcesPreviewSection6 />
      <ProcessSection6 />
      <FinalCtaSection6 />
      <SiteFooter6 />
    </main>
  );
}
